import classNames from 'classnames'
import type { FacetValue } from 'src/components/search/FilterV2/types'

type FilterButtonProps = {
  facetKey: string
  facetValue: FacetValue | undefined
  onClick: (facetValue: FacetValue) => void
  label: string
  Icon: React.ComponentType<{ color: string }>
}

const QuickFilterFacetButton = ({
  facetKey,
  facetValue,
  onClick,
  label,
  Icon,
}: FilterButtonProps) => {
  if (!facetValue) {
    return null
  }

  const { selected } = facetValue

  return (
    <button
      onClick={() => onClick(facetValue)}
      data-testId={`desktop-${facetKey}`}
      className={classNames(
        'flex flex-1 border rounded gap-2 p-4 flex-col justify-center ',
        selected
          ? 'border-restructure-background-blue'
          : 'border-restructure-background-neutral-5'
      )}
    >
      <Icon color="#3643BA" />
      <p
        className={classNames(
          'font-medium text-sm font-inter text-left',
          selected ? 'text-primaryBlue' : 'text-restructure-primary'
        )}
      >
        {label}
      </p>
    </button>
  )
}

export default QuickFilterFacetButton
